import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  wrapper: {
    paddingBottom: '8px',
  },
  label: {
    display: 'inline-block',
    marginBottom: '5px',
    textTransform: 'uppercase',
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#555',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #dcdcdc',
    borderRadius: '4px',
    transition: 'box-shadow 200ms ease',
    backgroundColor: '#fff',
  },
  inputWrapperFocused: {
    boxShadow: '0 0 0 3px #ffc4f4',
  },
  input: {
    flex: '1 1 auto',
    border: 'none',
    outline: 'none',
    borderRadius: '4px',
    padding: '7px 8px',
    color: '#555',
    fontSize: '14px',
    backgroundColor: 'transparent',
    minWidth: 0,
  },
  clearButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0 8px',
    color: '#999',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
})

export { useStyles }
